@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/_spacers.scss';
@import '@helsenorge/designsystem-react/scss/_breakpoints.scss';
@import '@helsenorge/designsystem-react/scss/_palette.scss';

.tableofcontents {
  border-top: 1px solid $neutral600;
  border-bottom: 1px solid $neutral600;

  &__title-container {
    display: flex;
    align-items: center;
    padding: getSpacer(s) getSpacer(m) getSpacer(s) getSpacer(s);

    @media (min-width: map.get($grid-breakpoints, lg)) {
      padding-right: getSpacer(l);
    }
  }

  &__title {
    margin-left: getSpacer(2xs);
    margin-right: auto;

    [dir='rtl'] & {
      margin-left: auto;
      margin-right: getSpacer(2xs);
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: getSpacer(s);
    align-items: start;
    padding: getSpacer(2xs) getSpacer(m) getSpacer(l);

    @media (min-width: map.get($grid-breakpoints, lg)) {
      padding-right: getSpacer(l);
    }
  }
}
